import Swiper from "swiper/bundle";

const GallerySlider = () => {
  const gallerySliders = [...document.querySelectorAll('.gallery__slider')];

  const initializeSlider = () => {
    gallerySliders.forEach((gallerySlider) => {
      const slides = [...gallerySlider.querySelectorAll('.swiper-slide')];
      const controls = gallerySlider.querySelector(".swiper-controls");
      const shouldInitializeSlider = slides.length > 1;
      
      if (!shouldInitializeSlider) {
        if (controls) {
          controls.classList.add("d-none");
        }
      }

      if (shouldInitializeSlider) {
        if (controls) {
          controls.classList.remove("d-none");
        }

        const galleryCarousel = new Swiper(gallerySlider, {
          slidesPerView: 1,
          loop: true,
          scrollbar: {
            el: '.swiper-scrollbar',
          },
          navigation: {
            nextEl: '.swiper__button-next',
            prevEl: '.swiper__button-prev',
          },
        });
      }
    });
  };

  initializeSlider();

  window.addEventListener('resize', () => {
    gallerySliders.forEach((gallerySlider) => {
      const swiperInstance = gallerySlider.swiper;
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
      }
    });
    initializeSlider();
  });
};

export default GallerySlider;